import { AxiosResponse } from 'axios';
import { all, AllEffect, ForkEffect, put, PutEffect, select, SelectEffect, takeEvery, takeLatest } from 'redux-saga/effects';
import { COMPARE_PRODUCTS_COOKIE_NAME } from 'b2b-apps/core/product/redux/productsCompare/types';
import { getCookie, setCookie } from 'b2b-apps/shop/common/utils/storage/cookies';
import { updateProductsCompareSettings } from 'b2b-apps/shop/settings/redux/actionCreators';
import { CHANGE_PAGE_SIZE, CHANGE_SORTING, CHANGE_VIEW_TYPE, SET_IS_COMPARISON_BAR_CLOSED } from 'b2b-apps/shop/settings/redux/actionTypes';
import { getCatalogSettings } from 'b2b-apps/shop/settings/redux/selectors';
import { SetIsComparisonBarClosedAction, SettingsProductsCompareType } from 'b2b-apps/shop/settings/redux/types';

export const SETTINGS_COOKIE_NAME = 'settings';

export const getCookieSetting = (key: string, defaultValue: any = null): any => {
  const settings = getCookie(SETTINGS_COOKIE_NAME);

  if (settings && settings[key]) {
    return settings[key] || defaultValue;
  }

  return defaultValue;
};

function* updateSettingsCookieSaga(): Generator<SelectEffect, void, Record<string, any>> {
  const settings = yield select(getCatalogSettings);

  setCookie(SETTINGS_COOKIE_NAME, settings);
}

function* setIsComparisonBarClosedSaga(action: SetIsComparisonBarClosedAction): Generator<
  PutEffect,
  void,
  AxiosResponse<SettingsProductsCompareType>
> {
  const cookie = getCookie(COMPARE_PRODUCTS_COOKIE_NAME) as SettingsProductsCompareType;
  const { isClosed } = action.payload;
  const settings = { ...(cookie || {}), isClosed };

  setCookie(COMPARE_PRODUCTS_COOKIE_NAME, settings);
  yield put(updateProductsCompareSettings(settings));
}

export function* settingsSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeLatest(CHANGE_PAGE_SIZE, updateSettingsCookieSaga),
    takeLatest(CHANGE_SORTING, updateSettingsCookieSaga),
    takeLatest(CHANGE_VIEW_TYPE, updateSettingsCookieSaga),
    takeEvery(SET_IS_COMPARISON_BAR_CLOSED, setIsComparisonBarClosedSaga),
  ]);
}
